import React, {useState, useEffect} from "react";
import styled from 'styled-components';
import CitizenCard from './CitizenCard';
import Data from './data/data.json'

const TitleDiv = styled.div`
    font-size: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 20%;
    margin-left: 4%;
`

export default function CitizenData() {
    return (
    <div className="CitizenData">
        <TitleDiv>
        <h1>Voice Command</h1>
        <h1>Output</h1>
        </TitleDiv>
        {Data.map(data => {
            return (
                <CitizenCard 
                command={data.command}
                line={data.line}
                />
            )
        })}
    </div>
    )
}